export const engagementPredictionFiltersPreviewAppGroupIdType =
  "/engagement/prediction_filters_preview/:app_group_id";
